export default __webpack_public_path__ + "static/media/bookmarked.e15df3c9.svg";